import { GraduationCap, MapPin, Phone, Globe, Mail, Facebook, Twitter, Instagram, Linkedin, Youtube } from "lucide-react";
import { COLLEGE, PROGRAMS } from "../../lib/constants";

const Footer = () => {
  return (
    <footer className="relative bg-megha-text text-slate-300 pt-16 md:pt-20 pb-8 overflow-hidden" data-testid="footer">
      <div className="absolute inset-0 grid-pattern opacity-[0.04]" />
      <div className="absolute -bottom-32 left-1/2 -translate-x-1/2 font-heading font-black text-[180px] md:text-[280px] text-white/[0.03] leading-none whitespace-nowrap pointer-events-none">
        MIETW
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-megha-primary to-megha-accent flex items-center justify-center text-white">
                <GraduationCap className="w-6 h-6" />
              </div>
              <div>
                <div className="font-heading font-extrabold text-white text-lg leading-tight">{COLLEGE.short}</div>
                <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500">B.Tech Admissions 2026</div>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed max-w-md">
              {COLLEGE.name} — a UGC autonomous, NAAC 'A' grade women's engineering institution
              in {COLLEGE.location}. Highest package: <span className="text-megha-highlight font-bold">{COLLEGE.highestPackage}</span>.
            </p>

            <div className="mt-6 flex gap-2">
              {[Facebook, Twitter, Instagram, Linkedin, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  data-testid={`social-${i}`}
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-megha-accent hover:border-megha-accent hover:text-white transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-xs font-bold tracking-[0.16em] uppercase text-white mb-4">Programs</div>
            <ul className="space-y-2.5 text-sm">
              {PROGRAMS.slice(0, 7).map((p) => (
                <li key={p.code}>
                  <a href="#programs" className="hover:text-megha-highlight transition-colors">
                    {p.code} <span className="text-slate-500">— {p.title.split("&")[0].trim().split(" ").slice(0, 3).join(" ")}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs font-bold tracking-[0.16em] uppercase text-white mb-4">Reach Us</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 mt-0.5 text-megha-highlight shrink-0" />
                <span>{COLLEGE.location}</span>
              </li>
              {COLLEGE.phones.map((p) => (
                <li key={p} className="flex items-start gap-2.5">
                  <Phone className="w-4 h-4 mt-0.5 text-megha-highlight shrink-0" />
                  <a href={`tel:${p.replace(/\s/g, "")}`} className="hover:text-megha-highlight" data-testid={`footer-phone-${p.replace(/\s/g, "")}`}>{p}</a>
                </li>
              ))}
              <li className="flex items-start gap-2.5">
                <Globe className="w-4 h-4 mt-0.5 text-megha-highlight shrink-0" />
                <a href={`https://${COLLEGE.website}`} target="_blank" rel="noreferrer" className="hover:text-megha-highlight">
                  {COLLEGE.website}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 mt-0.5 text-megha-highlight shrink-0" />
                <a href={`mailto:${COLLEGE.email}`} className="hover:text-megha-highlight">{COLLEGE.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {COLLEGE.name}. All rights reserved.</div>
          <div className="flex flex-wrap gap-4">
            {COLLEGE.codes.map((c) => (
              <span key={c}>
                {c} — <span className="text-megha-highlight font-semibold">{COLLEGE.codeWord}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
